module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--profile-102170ed67dcf209e6a203136b77776d.png";